import { mapGetters } from 'vuex'
import { HttpVsStock } from '@/service/boss/allot';
import BaseMixin from '@/views/mixin';
import { Button } from 'view-design';
export default {
	props: ['id', 'erpSku', 'stockVirtualGroupRuleName'],
	mixins: [BaseMixin],
	data() {
		return {
			title: false,
		}
	},
	mounted() {
		this.updateList({ stockVirtualGroupRuleItemId: this.id, erpSku: this.erpSku, stockVirtualGroupRuleName : this.stockVirtualGroupRuleName });
	},
	methods: {
		httpList: HttpVsStock
	},
	computed: {
		columns() {
			return [{
				title: this.$t('fbb.account.cusdisacountrate_source_type',{defaultValue:'来源类型'}),
				key: 'sourceType',
				width: 100,
				render:(h, { row })=>{
					switch (row.sourceType) {
						case 1: return <Button type='primary' size='small'>{this.$t('fbb.headlogistics.chushihua',{defaultValue:'初始化'})}</Button>; break;
						case 2: return <Button type='primary' size='small'>b2c{this.$t('erp.channelbase.order',{defaultValue:'订单'})}</Button>; break;
						case 3: return <Button type='primary' size='small'>{this.$t('global.common.fbb',{defaultValue:'云仓'})}</Button>; break;
						case 4: return <Button type='primary' size='small'>{this.$t('erp.virtualstore.virtualdiallist',{defaultValue:'虚拟调拨单'})}</Button>; break;
						case 5: return <Button type='primary' size='small'>{this.$t('erp.virtualstore.addingrules',{defaultValue:'加入规则'})}</Button>; break;
						case 6: return <Button type='primary' size='small'>{this.$t('erp.virtualstore.cancelrules',{defaultValue:'取消规则'})}</Button>; break;
						case 7: return <Button type='primary' size='small'>{this.$t('fbb.headlogistics.chushihua',{defaultValue:'初始化'})}{this.$t('global.common.operation_cancel',{defaultValue:'取消'})}</Button>; break;
						case 8: return <Button type='primary' size='small'>{this.$t('erp.virtualstore.inventorycorrect',{defaultValue:'库存校正'})}</Button>; break;
					}
				}
			},
			{
				title: this.$t('erp.virtualstore.outputwarehouse',{defaultValue:'出入库'}),
				key: 'operationType',
				render:(h, { row })=>{
					switch (row.operationType) {
						case 1: return <Button type='primary' size='small'>{this.$t('erp.channelbase.outbound',{defaultValue:'出库'})}</Button>; break;
						case 2: return <Button type='primary' size='small'>{this.$t('fbb.inventory.inbound',{defaultValue:'入库'})}</Button>; break;
						case 3: return <Button type='primary' size='small'>{this.$t('erp.product.reserved',{defaultValue:'预留'})}</Button>; break;
						case 4: return <Button type='primary' size='small'>{this.$t('erp.virtualstore.releasereserve',{defaultValue:'释放预留'})}</Button>; break;
						case 5: return <Button type='primary' size='small'>{this.$t('erp.virtualstore.releasereserve',{defaultValue:'释放预留'})}+{this.$t('erp.channelbase.outbound',{defaultValue:'出库'})}</Button>; break;
					}
				}
			},
			{
				title: this.$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'}),
				key: 'stockVirtualGroupRuleName',
				render: (h, { row }) => {
					return <span>{row.stockVirtualGroupRuleName}</span>
				}
			},
			{
				title: 'SourceNo',
				key: 'sourceNo',
			},
			{
				title: 'lotNo',
				key: 'lotNo',
			},
			{
				title: this.$t('erp.virtualstore.stepcurrentinventory',{defaultValue:'梯级当前库存量'}),
				key: 'leftQuantity',
			},
			{
				title: this.$t('erp.virtualstore.numberdeals',{defaultValue:'交易数量'}),
				key: 'inQuantity',
			},
			{
				title: this.$t('erp.virtualstore.cascadesurplus',{defaultValue:'梯级剩余库存量'}),
				key: 'totalQuantity',
			},
			{
				title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
				key: 'updatedAt',
			}];
		},
	},
};



